import { core_v1_DataSource_FieldUtils } from '@antimatterhq/asl-api-ts-v1';
import { filterStringArray } from './datasourceUtils';
import { JSONExtractionSchemaValues } from '@/zod/schemas/dataSource/Common';
import { filterNulls } from '@/utils/filterNulls';

export const getJSONExtractValues = (
  utils?: core_v1_DataSource_FieldUtils | null,
): JSONExtractionSchemaValues[] => {
  const jsonExtract = filterNulls(utils?.jsonExtract);

  return jsonExtract.map((json) => ({
    source: json.source ?? '',
    omitFields: json.omitFields ?? [''],
    embed: !!json.embedColumn,
    embedColumn: json.embedColumn ?? '',
    duplicatePrefix: json.duplicatePrefix ?? '',
  }));
};

export const setJsonExtract = (
  jsonExtractValues: JSONExtractionSchemaValues[],
): core_v1_DataSource_FieldUtils['jsonExtract'] | undefined => {
  if (jsonExtractValues.length === 0) {
    return undefined;
  }

  return jsonExtractValues.map((json) => ({
    source: json.source,
    omitFields: filterStringArray(json.omitFields),
    embedColumn: json.embed ? json.embedColumn || undefined : undefined,
    duplicatePrefix: !json.embed
      ? json.duplicatePrefix || undefined
      : undefined,
  }));
};
